import { FxQuotesCarousel } from "./FxQuotesCarousel";

/** Restores the bordered card around Cotações (shared with Stables `.stables-quotes-card`). */
export const FxQuotesSection = ({
  showViewAll = true,
  viewAllLink,
  compact = false,
}) => (
  <div className={`stables-quotes-card ${compact ? "mb-4" : "mb-5"}`}>
    <FxQuotesCarousel
      showViewAll={showViewAll}
      viewAllLink={viewAllLink}
      compact={compact}
      embedded
    />
  </div>
);
